var map = {
	"./BlogHomePage.tsx": 38892,
	"./BlogListPage.tsx": 51959,
	"./BlogPage.tsx": 74140,
	"./BudgetDetailPage.tsx": 98097,
	"./BudgetSummaryPage.tsx": 32693,
	"./BuyingListDetailsPage.tsx": 79032,
	"./BuyingListPage.tsx": 23439,
	"./ExpenditureByMfgPage.tsx": 87873,
	"./ExpenditureByProductPage.tsx": 30230,
	"./ExpenditureByPurchaserPage.tsx": 40733,
	"./ExpenditurePage.tsx": 36556,
	"./InvoiceSummaryPage.tsx": 35888,
	"./MonthlyExpensePage.tsx": 59314,
	"./OrderFrequencyPage.tsx": 23867,
	"./PromotionDetailPage.tsx": 13878,
	"./ReportingHomePage.tsx": 97823,
	"./ServiceHistoryPage.tsx": 37660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16481;